export default __webpack_public_path__ + "static/media/section1-bg2-h5.bc12cdac.png";